import { MemberType } from 'types/member/memberCloset';

export const memberTypeLabel = {
  [MemberType.NONE]: 'None',
  [MemberType.ADMIN]: 'Group Admin',
  [MemberType.COLLABORATOR]: 'Collaborator',
  [MemberType.EDITOR]: 'Editor',
  [MemberType.VIEWER]: 'Viewer',
};
